// @codekit-prepend "/js/firebase-init.js";
// @codekit-prepend "/vendor/vue.js";
// @codekit-prepend "/js/utils.js";


// Firebase Data
firebase.auth().onAuthStateChanged(async function (data) {
    if (sensePathApp && data) {
        getPrices();
        getPreviousSubscriptions();
        ref.child("users")
            .child(data.uid)
            .child('pupils')
            .on("value", function (snapshot) {
                sensePathApp.totalProfiles = snapshot.numChildren();
            }
            );
        toggleLoading(false);
    }
});

// Vue App
var sensePathApp = new Vue({
    el: "#sense-path-app",
    data: function () {
        return {
            authData: null,
            userData: {
                uid: ""
            },
            subscriptionType: null,
            pupil: {},
            newImage: null,
            totalProfiles: 0,
            profileLimit: 2,
            products: [],
            firstYearDiscount: false,
            chosenProduct: 0
        };
    },
    methods: {
        logout: function () {
            console.log("logging out");
            firebase
                .auth()
                .signOut()
                .then(function () {
                    // Sign-out successful.
                })
                .catch(function (error) {
                    console.log(error);
                });
        },
        addNewPupil: function () {
            this.pupil.dateAdded = Date.now();
            this.pupil.imageUrl = this.newImage;
            db.ref("/users/" + this.authData.uid + "/pupils")
                .push(this.pupil)
                .then(function (snapshot) {
                    var key = snapshot.key;
                    window.location = "/profile/?pid=" + key;
                });
        },
        selectImage: function (event, context) {
            let imgToPick;
            if (event.target.tagName == 'DIV') {
                imgToPick = event.target.querySelector('img');
            } else if (event.target.tagName == 'IMG') {
                imgToPick = event.target;
            }
            const contanerDiv = imgToPick.closest('.image-selection');
            const siblings = n => [...n.parentElement.children].filter(c => c != n);
            siblings(contanerDiv).forEach(s => s.classList.remove('selected'));
            contanerDiv.classList.add('selected');
            this.newImage = imgToPick.src;
        },
        canAddProfiles: canAddProfiles,
        mustUpgrade: mustUpgrade
    },
    computed: {
        randomImageIDs: function () {
            const randomImageIDs = [];
            for (let index = 0; index < 8; index++) {
                randomImageIDs.push(makeRandom(12));
            }
            return randomImageIDs;
        }
    },
    watch: {
        products: function (val) {
            if (val) {
                this.chosenProduct = getCorrectProduct();
            }
        },
        totalProfiles: function (val) {
            if (val > 0) {
                this.chosenProduct = getCorrectProduct();
            }
        }
    },
    filters: {
        price: priceFilter
    }
});

